import { Injector } from '@angular/core';
import { identity, lazyGenerator, Generator } from './../../utils';
import { UnaryFunction } from 'rxjs';

/**
 * Performs a lazy lookup of a dependency via an injector
 *
 * @param aInjector the injector
 * @param aToken   the token
 * @param aDefault an optional default of fallback token
 *
 * @return lazy injection result
 */
export function lazyInjector<T, R = T>(
  aInjector: Injector,
  aToken: any,
  aDefault?: T,
  aTransform?: UnaryFunction<T, R>
): Generator<R> {
  // transformer function
  const fct = (aTransform || identity) as UnaryFunction<T, R>;
  // dispatch
  return lazyGenerator(() => fct(aInjector.get(aToken, aDefault) as T));
}
